module.exports = __webpack_public_path__ + "img/staff_women.3291f01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff_women.png
// module id = tmQR
// module chunks = 1